import {Action} from '@ngrx/store';
import {type} from '../utils/type';
import {CATEGORY} from '../common/category.common';

export interface IUserActions {
    LOAD_USER: string;
    LOAD_USER_SUCCESS: string
    LOAD_USER_FAILURE: string
    CLEAR_USER: string
}

export const ActionTypes: IUserActions = {
    LOAD_USER: type(`${CATEGORY} Load User`),
    LOAD_USER_SUCCESS: type(`${CATEGORY} Load User Success`),
    LOAD_USER_FAILURE: type(`${CATEGORY} Load User Failure`),
    CLEAR_USER: type(`${CATEGORY} Clear User`)
};

export class LoadUserAction implements Action {
    type = ActionTypes.LOAD_USER;
    payload: string = null;
}

export class LoadUserSuccessAction implements Action {
    type = ActionTypes.LOAD_USER_SUCCESS;
    constructor(public payload: any) {
    }
}

export class LoadUserFailureAction implements Action {
    type = ActionTypes.LOAD_USER_FAILURE;
    payload: string = null;
}

/**
 * ログイン・ログアウトのときに、前のユーザの情報 (ユーザ・支部・設定・年度) を捨てる。
 * 残っていると、次にログインしたユーザの画面が前のユーザの役割で決まってしまう
 * (ブロックのユーザの後に支部のユーザでログインすると、ブロックの画面へ移る)。
 */
export class ClearUserAction implements Action {
    type = ActionTypes.CLEAR_USER;
    payload: string = null;
}

export type Actions
    = LoadUserAction
    | LoadUserSuccessAction
    | LoadUserFailureAction
    | ClearUserAction
